export default __webpack_public_path__ + "static/media/Rectangle -5.3d065702.png";